import React from "react";
import PropTypes from "prop-types";
import {pseudoText, pseudoTitle} from "../../constants";
import TitleWithTextComponent from "./TitleWithTextComponent";

class TitleWithText extends React.Component {
render() {
    const {title, text, titleSize} = this.props;

return (
    <TitleWithTextComponent title={title} text={text} titleSize={titleSize}/>
)}}

TitleWithText.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    titleSize: PropTypes.string,
};

TitleWithText.defaultProps = {
    title: pseudoTitle,
    text: pseudoText,
    titleSize: "25px",
};

export default TitleWithText